// Identify which component is uploading the file
export enum FileUploadSourceType {
    AcquisitionPropertyDetails = 'AcquisitionPropertyDetails',
    ActionRequired = 'ActionRequired'
    
  }

export enum FilterDetailsSourceType {
    AcqnFilter = 'AcqnFilter',
    AcqnInsuranceFilter = 'AcqnInsuranceFilter',
    Acquisitions = 'Acquisitions',
    LenderRanking = 'LenderRanking',
    DataFiles = 'DataFiles',
    INSAcq = 'INS_Acq',
    INSDataFiles = 'INS_DFiles',
    INSLenderRanking = 'INS_LRanking',
}

export enum DDTabName {
    ActionRequired = 'Action Required',
    LenderRanking = 'Lender Ranking',
    Acquisitions = 'Acquisitions',
    DataFiles = 'Data Files'
}